import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const CalendarQuestionMarkIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g clipPath="url(#calendar-question-mark-icon_svg__a)">
                <path
                    stroke="currentColor"
                    d="M10 17.5H3.2a.7.7 0 0 1-.7-.7V4.2c0-.4.3-.7.7-.7h13.6c.4 0 .7.3.7.7V10m-12-8v3m9-3v3m-12 2.5h15"
                />
                <path
                    fill="currentColor"
                    d="m14.7 19.5.2-1.3.5-.8.7-.5.4-.4a1.6 1.6 0 0 0 .5-1.1l-.2-.7c-.2-.2-.3-.4-.6-.5l-.7-.2c-.2 0-.4 0-.7.2-.2 0-.4.2-.5.4l-.2.9H13c0-.5.1-1 .4-1.3.2-.3.5-.6.9-.8.3-.2.8-.2 1.2-.2.5 0 1 0 1.3.3.4.2.7.4.9.8.2.3.3.7.3 1.2 0 .3 0 .5-.2.8 0 .3-.2.5-.4.7l-.6.5-.6.5-.3.6-.1.9h-1Zm.6 2.6-.6-.3a.7.7 0 0 1-.2-.5c0-.2 0-.4.2-.5l.6-.3c.2 0 .4.1.5.3.2.1.2.3.2.5v.4l-.3.3h-.4Z"
                />
            </g>
            <defs>
                <clipPath id="calendar-question-mark-icon_svg__a">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    </IconWrapper>
)
